import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
declare var $: any; // TODO show modal in othe way


// Services
import {
  UserService, ResourceService, CalendarLanguagueService
} from "@services/index.service";

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

//Constants
import { AppConstants } from '@app/appConstants';

import { environment } from "@environments/environment";

/** Esta página permite añadir personas dependientes del usuario del Portal y gestionarlos */
@Component({
  selector: 'app-mydependents',
  templateUrl: './mydependents.page.html',
  animations: environment.ANIMATIONS
})
export class MydependentsComponent implements OnInit {

  registerOnlyWithPin = environment.REGISTER_ONLY_WITH_PIN;
  maxDate = new Date();
  /** Información que solicitamos del dependiente. El resto la cogemos del propio usuario */
  dependent: any = {
    name: null,
    lastname: null,
    birthDate: null,
    birthname: null,
    pin: null,
    patnr: null
  };
  alertDanger: string;
  selectedDependent;

  constructor(public _userService: UserService, public _resourceService: ResourceService, public locale: CalendarLanguagueService) {
    /** Configuración del calendario */
    
  }

  ngOnInit() {
  }

  /** Comprobamos que tenemos todos los datos para dar de alta a un dependiente */
  checkDependantData() {
    if (!this.dependent.name || !this.dependent.lastname) {
      this.alertDanger = "NAME_AND_LASTNAME_ARE_REQUIRED";
    } else if (!this.dependent.birthDate || typeof (this.dependent.birthDate) == 'string' && moment(this.dependent.birthDate, "DD-MM-YYYY").format('YYYY-MM-DD') == 'Invalid date') {
      this.alertDanger = "PLEASE_SELECT_VALID_DATE_CAN_USE_CALENDAR";
    } else {
      this.addDependent();
    }
  }

  /** Creamos el dependiente con la información recogida y con otra que procede del propio usuario y delegamos en el _userService
   * el comunicarse con el back y esperamos respuesta. Si es correcta de nuevo pedimos los datos del usuario para tener la nueva
   * información.
   */
  addDependent() {

    let birthDate = this._resourceService.formatDate(this.dependent.birthDate);
    let params: any = {
      name: this.dependent.name,
      lastname: this.dependent.lastname,
      secondSurname: this.dependent.birthname,
      birthDate: birthDate,
      patnr: this.dependent.patnr,
      phoneNumber: this._userService.user.phoneNumber,
      address: this._userService.user.address,
      city: this._userService.user.city,
      postalCode: this._userService.user.postalCode,
      country: this._userService.user.country
    };
    if (this.dependent.pin) {
      params.pin = this.dependent.pin
      delete this.dependent.pin;
    }
    this._userService.addDependent(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this._userService.getDependents().subscribe(data => {
          let response = data as ResponseDataBase;
          this._userService.user.dependents = response.result;
          this._userService.loading = false;
          sessionStorage.setItem('dataPatient', JSON.stringify(this._userService.user));
          $('#AddDependentModal').modal('hide');
        });
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._userService.getDependents().subscribe(data => {
          let response = data as ResponseDataBase;
          this._userService.user.dependents = response.result;
          this._userService.loading = false;
        });
        this._userService.loading = false;
      }

      this._userService.user.dependents = response.result;
      this._userService.loading = false;
    },
      (error) => {
        this._resourceService.alert = error;
        this._userService.loading = false;
      });
  }

  selectDependentToDelete(dependent) {
    this.selectedDependent = dependent;
  }

  clearAlert() {
    
    delete this.alertDanger;
    delete this.dependent.pin;
  }

  registerDependentWithPin() {
    let params = {
      pinuser: this.dependent.pin
    };
    this._userService.getpatientpin(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.dependent.name = response.result[0].name;
        this.dependent.lastname = response.result[0].lastname;
        this.dependent.birthDate = response.result[0].birthDate;
        this.dependent.patnr = response.result[0].patnr;
        /* if (this._userService.dependantIsFamiliar(this._userService.user.nhsNumber, response.result[0].nhsNumber)) {
          this.addDependent();
        } else {
          this.alertDanger = 'CANT_ADD_DEPENDENT';
        } */
        this.addDependent();
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this._userService.loading = false;
    });
  }

  /** Pedimos al _userService que elimine el usuario y esperamos respuesta. Si es correcta de nuevo pedimos los datos 
   * del usuario para tener la nueva información.
   */
  deleteDependent() {
    let params = {
      dependentId: this.selectedDependent.id
    }
    this._userService.deleteUser(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this._userService.user.dependents = [];
        this._userService.getDependents().subscribe(data => {
          let response = data as ResponseDataBase;
          this._userService.user.dependents = response.result;
          this._userService.loading = false;
          sessionStorage.setItem('dataPatient', JSON.stringify(this._userService.user));
        });
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._userService.loading = false;
      }
    });
  }

}
